function toLink(value?: string) {
  if (!value) return value;
  if (value.startsWith('https://') || value.startsWith('http://')) {
    return value;
  }
  return `https://${value}`;
}
export default toLink;
